import React, { Component } from 'react';
import NavBar from './components/navbar';
import { HashRouter, BrowserRouter, Route, Routes } from 'react-router-dom';
import TimeView from './components/TimeView.js';
import AboutMe from './components/AboutMe.js';
import ProjectPage from './components/ProjectPage.js';
import SchwabCallback from './components/SchwabCallback.js';
import SchwabMarketDataCallback from './components/SchwabMarketDataCallback.js';
import MoneyPrinter from './components/MoneyPrinter.js';
import Ad from './components/Ad.js';
import RequestServices from './components/RequestServices.js';
import './App.css';

class App extends Component {
  render() {
    // Check if current path is the Schwab OAuth endpoint
    const isSchwabOAuth = window.location.pathname === '/schwab/oauth';
    // Check if current path is the Schwab Market Data OAuth endpoint
    const isSchwabMarketDataOAuth = window.location.pathname === '/schwab/marketdata/oauth';
    // Check if current path is the Ad endpoint
    const isAdPage = window.location.pathname === '/ad';
    
    
    if (isSchwabOAuth) {
      // Use BrowserRouter for Schwab OAuth (no hash)
      return (
        <div className="App">
          <BrowserRouter>
            <main>
              <Routes>
                <Route path="/schwab/oauth" element={<SchwabCallback />} />
              </Routes>
            </main>
          </BrowserRouter>
        </div>
      );
    }
    
    if (isSchwabMarketDataOAuth) {
      // Use BrowserRouter for Schwab Market Data OAuth (no hash)
      return (
        <div className="App">
          <BrowserRouter>
            <main>
              <Routes>
                <Route path="/schwab/marketdata/oauth" element={<SchwabMarketDataCallback />} />
              </Routes>
            </main>
          </BrowserRouter>
        </div>
      );
    }
    
    if (isAdPage) {
      // Use BrowserRouter for Ad page (no hash, no navigation)
      return (
        <div className="App">
          <BrowserRouter>
            <main>
              <Routes>
                <Route path="/ad" element={<Ad />} />
              </Routes>
            </main>
          </BrowserRouter>
        </div>
      );
    }
    
    // Use HashRouter for all other routes
    return (
      <div className="App">
        <HashRouter>
          <NavBar />
          <main>
            <Routes>
              <Route path="/" element={<RequestServices />} />
              <Route path="/projects" element={<TimeView />} />
              <Route path="/about" element={<AboutMe />} />
              <Route path="/services" element={<RequestServices />} />
              <Route path="/moneyprinter" element={<MoneyPrinter />} />
              <Route path="/project/:slug" element={<ProjectPage />} />
              <Route path="*" element={<RequestServices />} />
            </Routes>
          </main>
        </HashRouter>
      </div>
    );
  }
}

export default App;
